import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetTotalAgents = async () => {
  /**
   * input: null
   * output: agents object
   * description: fetches all agents
   */
  try {
    const AgentsCollection = await collection(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents"
    );
    const q = query(AgentsCollection, where("is_deleted", "==", false));

    const AgentsSnapshot = await getDocs(q);
    let Agents = [];
    AgentsSnapshot.forEach((e) => Agents.push({ ...e.data(), id: e.id }));
    return Agents;
  } catch (error) {
    console.log(error);
  }
};

export default GetTotalAgents;
